import { mustFillSofaSeatsPartialSelectionRuleOptionsValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
export const occSeatingSinglePartialSofaRuleConfigValidator = Validator.object({
    enabled: Validator.boolean(),
    options: mustFillSofaSeatsPartialSelectionRuleOptionsValidator
});
//# sourceMappingURL=single-partial-sofa-rule.js.map